import { default as module } from './AbstractModule';
import { APP_NAME, html } from '../utils/environment';

/**
 * Announcement Bar for Top Banner model
 */
export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                dismiss: 'dismiss',
            },
        };
    }

    init() {
        const currentID = this.getData('id');

        if (currentID) {
            this.storageKey = `${APP_NAME}.announcement.${currentID}.dismissed`;
        } else {
            this.storageKey = `${APP_NAME}.announcement.dismissed`;
        }

        this.check();
    }

    check() {
        const currentTime  = parseInt(this.getData('timestamp') * 1000);
        const previousTime = parseInt(window.localStorage.getItem(this.storageKey));

        if (previousTime && previousTime > currentTime) {
            html.classList.add('hide-announcement-bar');
        }
    }

    dismiss() {
        html.classList.add('hide-announcement-bar');
        window.localStorage.setItem(this.storageKey, Date.now());
    }
}
